export const ZIPCODE_LENGTH = 5;
export const PAYMENTS_PAGE_SIZE = 20;
export const PAGINATION_THRESHOLD = 20;
export const PAGINATION_JUMP_CONTROLS_THRESHOLD = 11;
